import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import {
  Button,
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Label,
} from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EmptyList.css';

// Redirection
import Link from '../../Link';

// Locale
import messages from '../../../locale/messages';
import FormBox from '../../../components_new/common/FormBox';

class EmptyList extends Component {
  static propTypes = {
    formatMessage: PropTypes.func,
  };

  handleClick() {
    history.push('/user/addpayout');
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <FormBox header={formatMessage(messages.payoutMethod)}>
        <div className={cx(s.spaceTop3, s.textCenter)}>
          <span className={s.textTitle}>
            <FormattedMessage {...messages.addPayoutMethod} />
          </span>
        </div>
        <div className={s.textCenter}>
          <span className={s.textLead}>
            Yoodlize <FormattedMessage {...messages.paymentReleaseInfo1} />
          </span>
          <br />
          <span className={s.textLead}>
            <FormattedMessage {...messages.paymentReleaseInfo2} />
          </span>
        </div>
        <div className={cx(s.spaceTop4, s.space2, s.textCenter)}>
          <Link to={'/user/addpayout'} className={cx(s.button, s.btnPrimary)}>
            <FormattedMessage {...messages.addPayout} />
          </Link>
        </div>
      </FormBox>
    );
  }
}

export default injectIntl(withStyles(s)(EmptyList));



// WEBPACK FOOTER //
// ./src/components/Payout/PayoutList/EmptyList.js